
let a = [1,2,3];
a.forEach((item) => {
    console.log(item);
});
jQuery(() => {
    let $ = jQuery;
    $('.widget-calendar-list').each((i, item) => {
        $(item).load(cp.ajax_url, {
            action: 'get_cal',
            days: $(item).attr('data-days'),
            type: $(item).attr('data-type')
        });
    });
});